{
  "meta": {
    "industry": "SaaS",
    "fiscalYear": "FY2026",
    "currency": "USD"
  },
  "charts": {
    "dealsByMonth": {
      "type": "bar",
      "title": "Closed Deals by Month (FY2026)",
      "containerClass": "chartCard",
      "data": [
        { "month": "Feb", "deals": 32 },
        { "month": "Mar", "deals": 35 },
        { "month": "Apr", "deals": 38 },
        { "month": "May", "deals": 42 },
        { "month": "Jun", "deals": 39 },
        { "month": "Jul", "deals": 45 },
        { "month": "Aug", "deals": 41 },
        { "month": "Sep", "deals": 36 },
        { "month": "Oct", "deals": 31 }
      ],
      "xKey": "month",
      "yKey": "deals",
      "barColor": "hsl(202, 100%, 50%)",
      "barRadius": [4, 4, 0, 0],
      "heightPercent": 85
    },
    "enterpriseSplit": {
      "type": "pie",
      "title": "Deal Distribution: Enterprise vs Other",
      "containerClass": "chartCard",
      "data": [
        { "name": "Enterprise", "value": 26, "color": "hsl(202, 100%, 50%)" },
        {
          "name": "Other Segments",
          "value": 313,
          "color": "hsl(214, 32%, 75%)"
        }
      ],
      "layout": "side",
      "legend": {
        "items": [
          { "text": "Enterprise: 26 deals (8%)", "dotClass": "secondary" },
          { "text": "Other: 313 deals (92%)", "dotClass": "border" }
        ],
        "footer": "Enterprise = $2M iARR ($76.9K avg)"
      }
    },
    "enterpriseFunnel": {
      "type": "bar-horizontal",
      "title": "Enterprise Deal Count (All Time)",
      "containerClass": "chartCardSmall",
      "data": [
        { "category": "Won", "deals": 38 },
        { "category": "Pipeline", "deals": 196 },
        { "category": "Lost", "deals": 479 }
      ],
      "categoryKey": "category",
      "valueKey": "deals",
      "barColor": "hsl(202, 100%, 50%)",
      "barRadius": [0, 4, 4, 0],
      "height": 180,
      "yAxisWidth": 60,
      "tooltip": { "suffix": " deals" }
    },
    "winRate": {
      "type": "pie",
      "title": "Win Rate",
      "containerClass": "chartCardSmall",
      "data": [
        { "name": "Won", "value": 38, "color": "hsl(142, 76%, 36%)" },
        { "name": "Lost", "value": 479, "color": "hsl(0, 84%, 60%)" }
      ],
      "layout": "side",
      "flexClass": "chartFlex chartHeight44",
      "legend": {
        "size": "small",
        "items": [
          { "text": "Won: 38 deals", "color": "hsl(142, 76%, 36%)" },
          { "text": "Lost: 479 deals", "color": "hsl(0, 84%, 60%)" }
        ]
      }
    },
    "topPerformers": {
      "type": "bar",
      "title": "Top Enterprise Performers (FY2026)",
      "containerClass": "chartCardSmall gridSpan2",
      "data": [
        { "name": "Chloe B.", "deals": 2, "value": 300 },
        { "name": "Joe G.", "deals": 3, "value": 300 },
        { "name": "Felicity N.", "deals": 3, "value": 225 }
      ],
      "xKey": "name",
      "yKey": "value",
      "barColor": "hsl(142, 76%, 36%)",
      "barRadius": [4, 4, 0, 0],
      "height": 180,
      "tooltip": { "prefix": "$", "suffix": "K" },
      "legend": { "show": true },
      "barName": "iARR ($K)"
    }
  },
  "conversations": [
    {
      "question": "how many deals have we closed so far this year",
      "pauseAfterResponseMs": 1500,
      "blocks": [
        { "type": "chart", "chartId": "dealsByMonth", "delayMs": 1000 },
        {
          "type": "paragraph",
          "text": "We've closed 339 deals so far this fiscal year (FY2026, which runs from February 1, 2025 through January 31, 2026).",
          "delayMs": 0
        }
      ]
    },
    {
      "question": "how many of these were in our enterprise segment",
      "pauseAfterResponseMs": 2250,
      "blocks": [
        { "type": "chart", "chartId": "enterpriseSplit", "delayMs": 2000 },
        {
          "type": "paragraph",
          "text": "Of the 339 closed deals this fiscal year, 26 (8%) were in the Enterprise segment.",
          "delayMs": 0
        }
      ]
    },
    {
      "question": "how's the enterprise segment doing as a whole",
      "blocks": [
        { "type": "chart", "chartId": "enterpriseFunnel", "delayMs": 1250 },
        { "type": "chart", "chartId": "winRate", "delayMs": 1500 },
        { "type": "chart", "chartId": "topPerformers", "delayMs": 2000 },
        {
          "type": "heading",
          "text": "Enterprise Segment Performance Summary",
          "delayMs": 0
        },
        {
          "type": "paragraph",
          "text": "This fiscal year, we've closed 26 Enterprise deals, generating $2M in iARR. Chloe Buckland and Joe Graham are top performers: each has sold $300K in Enterprise iARR this year.",
          "delayMs": 0
        },
        {
          "type": "paragraph",
          "text": "All-time, we've won ~7% of Enterprise deals that are closed. With 196 opportunities currently in pipeline, we would expect to win ~14 deals. At an average deal size of $76.9K, the current enterprise pipeline represents ~$1.076M in closed iARR.",
          "delayMs": 0
        }
      ]
    }
  ]
}
